module.exports = __webpack_public_path__ + "static/media/icon-bottom-promo.3888b014.svg";